import { useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Typography } from 'shared';

import { Show } from 'shared/components/Show';

export const RedirectToSessionsIfNoNextSession = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const { email: emailFromParams } = useParams();
  const { getValues } = useFormContext();
  const [clientEmail, nextSessionStartDate] = getValues([
    'nextSessionAppointment.clientEmail',
    'nextSessionAppointment.startAt',
  ]);
  const participantEmail = clientEmail || emailFromParams;

  const participantSessionsLink = participantEmail
    ? `/hde/participants/${participantEmail}/sessions`
    : '';

  return (
    <Show
      when={nextSessionStartDate}
      fallback={
        <>
          <Button
            variant="outline"
            onClick={() => {
              navigate(participantSessionsLink);
            }}
          >
            <Typography>Go to sessions</Typography>
          </Button>
        </>
      }
    >
      {children}
    </Show>
  );
};
